import { render, staticRenderFns } from "./GlobalCampaignInfo.vue?vue&type=template&id=214e6224&scoped=true&"
import script from "./GlobalCampaignInfo.vue?vue&type=script&lang=js&"
export * from "./GlobalCampaignInfo.vue?vue&type=script&lang=js&"
import style0 from "./GlobalCampaignInfo.vue?vue&type=style&index=0&id=214e6224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e6224",
  null
  
)

export default component.exports